import React from 'react';

import { WalletList } from '@C/Reports/_utils/WalletList';

import { LedgerReport } from '../LedgerReport';

const WalletLedger = () => {
  return (
    <LedgerReport
      title="Wallet Ledger"
      entityLabel="Wallet Name"
      SelectorComponent={WalletList}
      source="WALLET"
      showTotals={true}
      dateRangeLimit={1}
      dateRangeLimitType="month"
    />
  );
};

export { WalletLedger };
